import { Field, useFormikContext } from "formik";

import { Autocomplete as FormikAutocomplete } from "formik-mui";
import TextField from "./TextField";
import { styled } from "@mui/system";

const StyledFormikAutocomplete = styled(FormikAutocomplete)`
  & .MuiAutocomplete-input {
    padding: 1rem 0.625rem !important;
  }

  & .MuiOutlinedInput-root {
    padding-top: 10px !important;
    min-width: 400px !important;
    width: 100% !important;
  }
`;
const Autocomplete = ({ label, multiple = false, ...props }) => {
  const { touched, errors } = useFormikContext();

  return (
    <>
      <Field
        key={props.key}
        name={props.name}
        component={StyledFormikAutocomplete}
        options={props.options || []}
        getOptionLabel={props.getOptionLabel}
        multiple={multiple}
        // limitTags={2}
        renderInput={(params) => (
          <TextField
            {...params}
            error={touched?.[props.name] && !!errors?.[props.name]}
            helperText={touched?.[props.name] && errors?.[props.name]}
            label={label}
          />
        )}
        {...props}
      />
    </>
  );
};

export default Autocomplete;
